import VueCroppie from 'vue-croppie';
import 'croppie/croppie.css'; // import the croppie css manually

export default (function (_ref) {
  var Vue = _ref.Vue;
  Vue.use(VueCroppie);
});